import React from "react";
import { cn } from "@/components/utils/utils";
import { useLanguage } from "@/contexts/LanguageContext";

interface ItineraryStatusBadgeProps {
  status: string;
  className?: string;
  hideDraftQuote?: boolean;
}

export const ItineraryStatusBadge: React.FC<ItineraryStatusBadgeProps> = ({
  status,
  className,
  hideDraftQuote = false
}) => {
  const { t } = useLanguage();
  
  const getStatusBadgeStyles = () => {
    switch (status) {
      case 'pending':
        return 'bg-white border border-gray-200 text-gray-800';
      case 'approved':
        return 'bg-green-100 border border-green-300 text-green-800';
      case 'sended':
        return 'bg-yellow-100 border border-yellow-300 text-yellow-800';
      case 'rejected':
        return 'bg-red-100 border border-red-300 text-red-800';
      case 'expired':
        return 'bg-red-100 border border-red-300 text-red-800';
      case 'draft':
        return 'bg-gray-100 border border-gray-300 text-gray-800';
      default:
        return 'bg-gray-900 text-white border border-gray-700';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'pending':
        return t('itinerary.statusPending');
      case 'approved':
        return t('itinerary.statusApproved');
      case 'sended':
        return t('itinerary.statusSended');
      case 'rejected':
        return t('itinerary.statusRejected');
      case 'expired':
        return t('itinerary.statusExpired');
      case 'draft':
        return t('itinerary.statusDraft');
      default:
        return t('itinerary.statusQuote');
    }
  };

  // Nascondi il badge se hideDraftQuote è true e lo status è draft o quote
  if (hideDraftQuote && (status === 'draft' || status === 'quote' || status === 'completed')) {
    return null;
  }

  return (
    <div className={cn(
      "px-3 py-1 rounded-full shadow-sm flex items-center gap-2",
      getStatusBadgeStyles(),
      className
    )}>
      <span className="text-xs font-medium">
        {getStatusText()}
      </span>
    </div>
  );
};
